import NapsterSpinner from '@components/NapsterSpinner';
import { extraQueryParams } from '@utils/constants';
import { useEffect, useRef } from 'react';
import { useAuth } from 'react-oidc-context';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function PartnerRedirect() {
  const { t } = useTranslation();
  const auth = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const hasStartedRef = useRef(false);

  useEffect(() => {
    if (hasStartedRef.current) return;
    if (auth.isLoading) return;
    const partner = searchParams.get('partner');
    const operator = searchParams.get('operator');

    if (!partner) {
      navigate('/', { replace: true });
      return;
    }

    hasStartedRef.current = true;
    const signUpToken = searchParams.get('signUpToken');

    auth
      .signinRedirect({
        extraQueryParams: {
          ...extraQueryParams,
          partner,
          ...(signUpToken ? { signUpToken, action: 'get-started' } : {}),
          ...(operator ? { operator } : {}),
        },
        state: { returnUrl: `/auth/partner/success?partner=${partner}` },
      })
      .catch((error) => {
        console.error(`Partner (${partner}) redirect sign-in error:`, error);
        hasStartedRef.current = false; // allow retry on error
        navigate('/', {
          state: { error: t('auth.authFailed') },
        });
      });
  }, [auth, navigate, searchParams, t]);

  return (
    <div className="flex items-center justify-center h-screen bg-black">
      <NapsterSpinner size="large" />
    </div>
  );
}

export { PartnerRedirect };
